import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertVideoCommand from './insertvideocommand';

export default class InsertVideoUI extends Plugin {

  init() {
    this.editor.commands.add('insertvideo', new InsertVideoCommand(this.editor));
  }
}